export default __webpack_public_path__ + "static/media/fr3.ca4b7661.webp";